module.exports = __webpack_public_path__ + "static/media/blue_nebula_FT.7e8f6800.png";